import React, { useEffect, useState } from 'react'
import WarehouseSpoil from '../WarehouseSpoil'
import { useDispatch } from 'react-redux'
import { getSpoilByStatus } from '../../../../models/warehouse/warehouse_spoil_m';

import Paginate from '../../../pagination/Paginate'
import Moment from 'react-moment';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const WarehouseSpoilValidasi = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [validasi, setValidasi] = useState([]);
    const [pagination, setPagination] = useState([]);

    const getData = async(page) => {
        try {
            const data = {
                status: 'belum',
                page: page
            }
            const response = await dispatch(getSpoilByStatus(data)).unwrap().catch((err) => {});
            setValidasi(response.data);
            setPagination(response.pagination);
        } catch (error) {
            
        }
    }

    useEffect(() => {
        getData(1);
    }, []);

    const handlePagination = (_, page) => {
        return getData(page)
    }

    const onDetail = (code) => {
        return navigate(`${code}`)
    }

    return (
        <WarehouseSpoil>
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <div style={{lineHeight: '60%'}}>
                                <h3>VALIDASI SPOIL PERGUDANGAN</h3>
                                <span>Validasi Spoil Pergudangan</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive mb-3">
                            <table className="table align-middle">
                                <thead>
                                    <tr>
                                        <th className="table-border-start text-center" style={{width: '5%'}}>
                                            <span className="form-control">No</span>
                                        </th>
                                        <th>
                                            <span className="form-control">Kode Spoil</span>
                                        </th>
                                        <th>
                                            <span className="form-control">Tanggal</span>
                                        </th>
                                        <th>
                                            <span className="form-control">Petugas</span>
                                        </th>
                                        <th className="text-center" style={{width: '15%'}}>
                                            <span className="form-control">Status</span>
                                        </th>
                                        <th className="text-center table-border-end" style={{width: '10%'}}>
                                            <span className="form-control">Action</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        validasi.map((data) => (
                                            <tr key={data.no}>
                                                <td className="text-center">{data.no}</td>
                                                <td>{data.code}</td>
                                                <td>
                                                    <Moment format="dddd, DD MMMM YYYY">{data.date}</Moment>
                                                </td>
                                                <td>{data.employee}</td>
                                                <td className="text-center">
                                                    <span className="badge bg-orange">Belum Divalidasi</span>
                                                </td>
                                                <td className="text-center">
                                                    <Button onClick={() => onDetail(data.code)} size="small" variant="contained" color="success">
                                                        Detail
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>

                        {/* pagination */}
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <span>Halaman : { pagination.current_page }</span>
                            </div>
                            {
                                pagination.pagination ? 
                                <Paginate count={pagination.total} page={pagination.current_page} onChange={handlePagination} /> : ''
                            }
                            <div>
                                <span>Total : { pagination.total } Data</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </WarehouseSpoil>
    )
}

export default WarehouseSpoilValidasi
